import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Container } from '@sm/wds-react';
import { TabletScreen } from '@sm/webassets';
import HeroFormCTA from '~app/components/HeroFormCTA';

import './hero-form-callout.scss';

const HeroFormCallout = ({ color, boldHeader, subHeader, formCopy }) => (
  <Container
    flex
    flexJustify="center"
    flexDirection="column"
    data-testid="HeroFormCallout"
    className="sm-hero-form-callout"
  >
    <Typography className="sm-hero-form-callout__header">
      <Typography
        component="section"
        variant="sectionTitle"
        color={`${color}`}
        className="sm-hero-form-callout__header--bold"
      >
        <strong>{boldHeader}</strong>
      </Typography>
      <Typography
        component="div"
        variant="body"
        color={`${color}`}
        className="sm-hero-form-callout__header--sub wds-p-t-3"
      >
        {subHeader}
      </Typography>
    </Typography>
    <Container flex>
      <HeroFormCTA className="sm-hero-form-callout__form" {...formCopy} />
      <TabletScreen>
        <Container className="sm-hero-form-callout__img" />
      </TabletScreen>
    </Container>
  </Container>
);

HeroFormCallout.propTypes = {
  color: PropTypes.string,
  boldHeader: PropTypes.string.isRequired,
  subHeader: PropTypes.string.isRequired,
  formCopy: PropTypes.shape({
    ctaFormEmail: PropTypes.string.isRequired,
    ctaFormNewsletterOptOut: PropTypes.string.isRequired,
    ctaFormPassword: PropTypes.string.isRequired,
    ctaFormPrivacyConsent: PropTypes.node.isRequired,
    ctaFormSubmit: PropTypes.string.isRequired,
    disclaimer: PropTypes.string.isRequired,
    utSource: PropTypes.string.isRequired,
    utSource2: PropTypes.string.isRequired,
  }).isRequired,
};

HeroFormCallout.defaultProps = {
  color: '#231f20',
};
export default HeroFormCallout;
